import React, { useEffect, useState } from "react";
import DotComponent from "./DotComponent";
import { Box, Button, IconButton, Modal, Stack, Typography } from "@mui/material";
import useStore from "../../Hooks/useStore";
import CloseIcon from "@mui/icons-material/Close";
import { axiosPrivate } from "../../api/axios/axios";
import CircularProgress from '@mui/material/CircularProgress';
import DangerousIcon from '@mui/icons-material/Dangerous';
import { toast } from "react-toastify";
const getRole = (role) => {
  const roleMap = { 100: "admin", 200: "developer", "000": "super admin", 300: "opration" };
  return roleMap[role];
};
const UserInfoCard = ({ data = {} }) => {
  // Safely parse user data and provide default values
  //   console.log(onClick, "onCLick");
  const [user, setUser] = useState({});
  //   console.log(user, "user");
  const userData = (() => {
    try {
      // Handle both string and object inputs
      const parsedUser = typeof user === "string" ? JSON.parse(user) : user;

      return {
        name: parsedUser.name || "Unknown User",
        email: parsedUser.email || "No email",
        role: getRole(parsedUser.role) || "N/A",
        id: parsedUser._id?.$oid || parsedUser._id || "Unknown ID",
        modules: Array.isArray(parsedUser.modules)
          ? parsedUser.modules.map((m) => m.$numberInt || m)
          : [],
        active: parsedUser.active || null,
        approved: parsedUser.approved || null,
      };
    } catch (error) {
      return {
        name: "Invalid User Data",
        email: "Error",
        role: "N/A",
        id: "Error",
        modules: [],
        active: null,
      };
    }
  })();

  useEffect(() => {
    if (Object.keys(data).length > 0) {
      setUser(data);
    }
  }, [data]);

  // console.log(userData, "userData");
  const { userProfile, setFetchAgain } = useStore();
  const [open, setOpen] = React.useState(false);
  const handleOpen = (e) => { e.stopPropagation();; setOpen(true) };
  const handleClose = () => setOpen(false);
  const handleUserDelete = (e, user) => {
    e.stopPropagation();
    console.log("User Delete Call for User : ", user)
    handleOpen(e)
  }
  const madalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    borderRadius: "10px",
    boxShadow: 24,
    p: 4,
  };
  const [loading, setLoading] = useState(false);
  const handleConfirmDeleteUser = async (_id) => {
    try {
      setLoading(true)
      const UPDATE_USER_INFO_URL = "/api/auth/updateuserinfo";

      const response = await axiosPrivate.put(UPDATE_USER_INFO_URL, {
        _id,
        active: false,
        approved: false
      });
      toast.success(response.data.msg);

      setFetchAgain(prev => !prev)
      handleClose()
    } catch (error) {
      toast.error(error.response.data.msg);
    } finally {
      setLoading(false)
    }
  };

  const roleBasedStyle = user.role === '000' ? "border-red-400 bg-red-500 "
    : user.role === '100' ? "border-orange-600 bg-orange-500" : user.role === '200' ? "border-blue-600 bg-blue-500" : "border-green-600 bg-green-500";
  return (
    <>
      <div className={`p-4 transition-shadow duration-300 bg-white rounded-lg shadow-md hover:shadow-lg `}>
        <div className="flex items-center justify-between mb-2 text-lg font-semibold text-gray-800 truncate">
          {userData.name}

          {userProfile.role === "000" && (user.active || user.approved) && (
            <Button
              onClick={(e) => handleUserDelete(e, userData)}
              size="small"
              variant="outlined"
              color="error"
            >
              Delete User
            </Button>
          )}
        </div>
        <div className="space-y-2 text-sm">
          <div className="flex justify-between">
            <span className="text-gray-500">ID:</span>
            <span className="text-xs truncate max-w-[100px]">
              {userData.id}
            </span>
          </div>
          <div className="flex justify-between">
            <span className="text-gray-500">Email:</span>
            <span className="font-medium truncate max-w-[150px]">
              {userData.email}
            </span>
          </div>
          <div className="flex justify-between">
            <span className="text-gray-500">Role:</span>
            <span className={`  px-2 py-0.5 rounded text-xs border text-white ${roleBasedStyle}`}>
              {userData.role}
            </span>
          </div>
          <div className="flex justify-between">
            <span className="text-gray-500">Modules:</span>
            <div className="flex gap-1">
              {userData.modules.map((module, index) => (
                <span
                  key={index}
                  className="bg-blue-50 text-blue-600 px-1.5 py-0.5 rounded text-xs"
                >
                  {module}
                </span>
              ))}
            </div>
          </div>
          <div className="flex justify-between">
            <span className="text-gray-500">Active:</span>
            <span className="">
              <DotComponent input={userData.active} />
              {/* {userData.active ? "true" : "false"} */}
            </span>
          </div>
          <div className="flex justify-between">
            <span className="text-gray-500">Approved:</span>
            <span className="">
              <DotComponent input={userData.approved} />
              {/* {userData.active ? "true" : "false"} */}
            </span>
          </div>
        </div>
      </div>
      <Modal
        open={open}
        onClose={(e, reason) => {
          e.stopPropagation?.();
          if (reason === "backdropClick" || reason === "escapeKeyDown") return;
          handleClose();
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={madalStyle}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography id="modal-modal-title" variant="h6" component="h2">
              <DangerousIcon /> Confirm Deletion
            </Typography>
            <IconButton
              aria-label="close"
              onClick={(e) => {
                e.stopPropagation?.();
                handleClose();
              }}
              sx={{ position: "absolute", top: 8, right: 8 }}
            >
              <CloseIcon />
            </IconButton>
          </Box>

          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            {
              loading ? (<div className="flex flex-col items-center justify-center">
                <b>{userData.name}</b> Start deleting.
                <CircularProgress />

              </div>) : (<>
                Are you sure you want to permanently delete <b>{userData.name}</b>{" "}
                account ? <br /> This action cannot be undone.
              </>)
            }


          </Typography>
          <Stack marginTop={2} direction={"row"} gap={2}>
            <Button
              onClick={(e) => {
                e.stopPropagation?.();
                handleConfirmDeleteUser(userData.id)
              }}
              color="error"
              variant="contained"
              disabled={loading}
            >
              Delete
            </Button>
            <Button
              onClick={(e) => {
                e.stopPropagation?.();
                handleClose();
              }}
              color="success"
              variant="contained"
              disabled={loading}
            >
              Cancele
            </Button>
          </Stack>
        </Box>
      </Modal>
    </>
  );
};

export default UserInfoCard;
